import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useNavigate, useParams, Link } from 'react-router-dom';
import '../../../assets/styles/payment.scss';
import '../../../assets/styles/qr.scss';
import { formatPrice, showErrorToasts, replaceNavigate } from '../../../services/helpers/Helper';
import { fetchOrder } from '../../../store/action/orderAction';
import imageDefault from '../../../assets/images/svg/ic-image-default.svg';
import { fetchPaymentMethod, paymentSubmit, payUrl } from '../../../store/action/paymentAction';
import { URL } from '../../../routers/constants';
import NotFound from './not-found';
import { error } from 'jquery';
import { PAYMENT_TYPE, PAYMENT_METHOD } from '../../../config/config';
import Modal from "../../shared/components/modal";
import IconQrViettelMoney from "../../../assets/icon/svg/payment/IconQrViettelMoney";
import ViettelMoney from "../../../assets/icon/svg/payment/ViettelMoney";
import Close from "../../../assets/icon/svg/close";

const Payment = (props) => {
   const navigate = useNavigate();
   const { fetchOrder, order, fetchPaymentMethod, payments, paymentSubmit, payUrl } = props;
   const params = useParams();
   const { id } = params;
   const [selectMethod, setSelectMethod] = useState(0);
   const [isLoad, setIsLoad] = useState(true);
   const [isShowQrCode, setIsShowQrCode] = useState(false);
   const [qrCode, setQrCode] = useState('');
   const [orderCode, setOrderCode] = useState('');
   const [shopId, setShopId] = useState(0);

   useEffect(() => {
      fetchOrder(id).then((response) => {
         if (response.data.shop_id) {
            fetchPaymentMethod(response.data.shop_id).then((response) => {
               if (response.data?.[0]) {
                  let idSelectMethod = (response.data?.[0].payment_method_sub_id) 
                                       ? (response.data?.[0].id + '_' + response.data?.[0].payment_method_sub_id) 
                                       : response.data?.[0].id + '_0';
                  setSelectMethod(idSelectMethod);
               }
            });
         }
      }).finally(() => {
         setIsLoad(false);
      });
   }, [id]);

   const formatMessage = (message) => {
      let text = [];
      if (message) {
         text = message.split(/\n/);
      }
      return text;
   }

   const handleSubmit = () => {
      if (!selectMethod) {
         showErrorToasts('Vui lòng chọn phương thức thanh toán!');
         return;
      }
      let [idMedthod, idSubMethod] =  selectMethod.split("_");

      if (idMedthod != PAYMENT_METHOD.COD && idMedthod != PAYMENT_METHOD.BANK) {
         payUrl(order.reference_code, idMedthod,idSubMethod)
            .then((response) => {
               const { qrCode, type, url, orderCode } = response;
               switch (type) {
                  case PAYMENT_TYPE.PAYMENT_URL:
                     window.open(url, '_self');
                     break;
                  case PAYMENT_TYPE.PAYMENT_QRCODE:
                     setIsShowQrCode(true);
                     setQrCode(qrCode);
                     setOrderCode(orderCode);
                     break;
                  default:
                     break;
               }
            }).catch((error) => {
               showErrorToasts('Lỗi');
            });
      } else {
         paymentSubmit(id, idMedthod, () => navigate(URL.SHOPPING_CART_THANK_YOU.replace(':id', id)));
      }
   }

   const closeQR = () => {
      setIsShowQrCode(false);
   }

   return (
      <React.Fragment>
         {order.id ?
            <div>
               {
                  order.payment_status == 1 ?
                     <div className="payment-container">
                        <div className=" flexbox ">
                           <div className="content">
                              <div className="wrap">
                                 <div className="main">
                                    <div className="main-header">
                                       <a href="/" className="logo">
                                          <h1 className="logo-text">{order.campaign_name}</h1>
                                       </a>
                                    </div>
                                    <div className="main-content">
                                       <div className="step-sections">
                                          <div className="section-header os-header">
                                             <div className="os-header-heading">
                                                <h2 className="os-header-title">
                                                   Đơn hàng đã thanh toán
                                                </h2>
                                                <span className="os-order-number">
                                                   Mã đơn hàng #{order.reference_code}
                                                </span>

                                             </div>
                                          </div>
                                          <div className="step-footer">
                                             <Link to={replaceNavigate(URL.SHOPPING_CART_THANK_YOU, order.reference_code)} className="step-footer-continue-btn btn-submit">
                                                <span className="btn-content">
                                                   Chi tiết đơn hàng
                                                </span>
                                                <i className="btn-spinner icon icon-button-spinner"></i>
                                             </Link>

                                          </div>
                                       </div>
                                    </div>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>
                     :
                     <div className="payment-container">
                        <div className=" flexbox ">
                           <div className="content">
                              <div className="wrap">
                                 <div className="main">
                                    <div className="main-header">
                                       <a href="/" className="logo">
                                          <h1 className="logo-text">{order.campaign_name}</h1>
                                       </a>
                                    </div>
                                    <div className="main-content">
                                       <div className="step-sections">
                                          <div className="section-header os-header">
                                             <div className="os-header-heading">
                                                <h2 className="os-header-title">
                                                   Thanh toán đơn hàng
                                                </h2>
                                                <span className="os-order-number">
                                                   Mã đơn hàng #{order.reference_code}
                                                </span>
                                             </div>
                                          </div>
                                          <div id="section-payment-method" className="section">
                                             <div className="section-header">
                                                <h2 className="section-title">Phương thức thanh toán</h2>
                                             </div>
                                             <div className="section-content">
                                                <div className="content-box">
                                                   {payments.map((item, index) => {
                                                      return (
                                                         <div className="radio-wrapper content-box-row" key={index}
                                                            onClick={() => setSelectMethod(item.payment_method_sub_id ? item.id + '_' + item.payment_method_sub_id : item.id + '_0')
                                                            }>
                                                            <label className="radio-label" for={"payment_method_" + index}>
                                                               <div className="radio-input">
                                                                  <input id={"payment_method_" + index} className="input-radio" type="radio" 
                                                                  checked={item.payment_method_sub_id ? (item.id + '_' + item.payment_method_sub_id)  == selectMethod : (item.id + '_0') == selectMethod} 
                                                                  />
                                                               </div>
                                                               <div className="radio-content-input">
                                                                  <img className="main-img" src={item.image} />
                                                                  <div>
                                                                     <p className="radio-label-primary">
                                                                        {item.name}
                                                                     </p>
                                                                     {item.instruction &&
                                                                        <div className="introduction">
                                                                           {formatMessage(item.instruction).map((line, index) => (
                                                                              <p key={index}>{line}</p>
                                                                           ))}
                                                                        </div>
                                                                     }

                                                                  </div>
                                                               </div>
                                                            </label>
                                                         </div>
                                                      )
                                                   })}
                                                </div>
                                             </div>
                                          </div>
                                          <div className="order-info">
                                             <div className="sidebar-content">
                                                <div className="order-summary order-summary-is-collapsed">
                                                   <h2>Tổng quan đơn hàng</h2>
                                                   <div className="order-summary-sections">
                                                      <div className="order-summary-section order-summary-section-product-list"
                                                         data-order-summary-section="line-items">
                                                         <table className="product-table">
                                                            <thead>
                                                               <tr>
                                                                  <th scope="col"><span className="visually-hidden">Hình ảnh</span></th>
                                                                  <th scope="col"><span className="visually-hidden">Mô tả</span></th>
                                                                  <th scope="col"><span className="visually-hidden">Số lượng</span></th>
                                                                  <th scope="col"><span className="visually-hidden">Giá</span></th>
                                                               </tr>
                                                            </thead>
                                                            <tbody>
                                                               {order.orderProducts.map((item, index) => {
                                                                  return (
                                                                     <tr className="product" key={index}>
                                                                        <td className="product-image">
                                                                           <div className="product-thumbnail">
                                                                              <div className="product-thumbnail-wrapper">
                                                                                 <img className="product-thumbnail-image" alt={item.product_name} src={item.product_image ? item.product_image : imageDefault} />
                                                                              </div>
                                                                              <span className="product-thumbnail-quantity" ariaHidden="true">{item.quantity}</span>
                                                                           </div>
                                                                        </td>
                                                                        <td className="product-description">
                                                                           <span className="product-description-name order-summary-emphasis">{item.product_name}</span>
                                                                           <span className="product-description-variant order-summary-small-text">
                                                                           </span>
                                                                        </td>
                                                                        <td className="product-quantity visually-hidden">{item.quantity}</td>
                                                                        <td className="product-price">
                                                                           <span className="order-summary-emphasis">
                                                                              {formatPrice(item.product_price * item.quantity)} đ
                                                                           </span>
                                                                        </td>
                                                                     </tr>
                                                                  )
                                                               })}
                                                            </tbody>
                                                         </table>
                                                      </div>
                                                      <div className="order-summary-section order-summary-section-total-lines payment-lines">
                                                         <table className="total-line-table">
                                                            <thead>
                                                               <tr>
                                                                  <th scope="col">
                                                                     <span className="visually-hidden">Mô tả</span>
                                                                  </th>
                                                                  <th scope="col">
                                                                     <span className="visually-hidden">Giá</span>
                                                                  </th>
                                                               </tr>
                                                            </thead>
                                                            <tbody>
                                                               <tr className="total-line total-line-subtotal">
                                                                  <td className="total-line-name">Tạm tính</td>
                                                                  <td className="total-line-price">
                                                                     <span className="order-summary-emphasis" >
                                                                        {formatPrice(order.grand_total)} ₫
                                                                     </span>
                                                                  </td>
                                                               </tr>
                                                               <tr className="total-line total-line-shipping">
                                                                  <td className="total-line-name">Phí vận chuyển</td>
                                                                  <td className="total-line-price">
                                                                     <span className="order-summary-emphasis">
                                                                        {formatPrice(order.shipping)} ₫
                                                                     </span>
                                                                  </td>
                                                               </tr>
                                                            </tbody>
                                                            <tfoot className="total-line-table-footer">
                                                               <tr className="total-line">
                                                                  <td className="total-line-name payment-due-label">
                                                                     <span className="payment-due-label-total">Tổng cộng</span>
                                                                  </td>
                                                                  <td className="total-line-name payment-due">
                                                                     <span className="payment-due-currency">VND</span>
                                                                     <span className="payment-due-price">
                                                                        {formatPrice(order.grand_total)} ₫
                                                                     </span>
                                                                     <span className="checkout_version" data_checkout_version="0">
                                                                     </span>
                                                                  </td>
                                                               </tr>
                                                            </tfoot>
                                                         </table>
                                                      </div>
                                                   </div>
                                                </div>
                                             </div>
                                          </div>
                                          <div className="step-footer">
                                             <input name="utf8" type="hidden" value="✓" />
                                             <button type="submit" className='step-footer-continue-btn btn-submit' onClick={handleSubmit}>
                                                Thanh toán đơn hàng
                                             </button>
                                             <p className="step-footer-info">
                                                <i className="icon icon-os-question"></i>
                                                <span>
                                                   Cần hỗ trợ? <a href="mailto:vtm.hienat.game.3@gmail.com">Liên hệ chúng tôi</a>
                                                </span>
                                             </p>
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                              </div>

                           </div>
                           {isShowQrCode &&
                              <Modal>
                                 <div className="qr-code">
                                    <div className="qr-code-content">
                                       <div className="header-qr flex-between-center">
                                          <i><ViettelMoney /></i>
                                          <div className="left flex-center">
                                             Thanh toán qua Viettel Money
                                          </div>
                                          <div className='close-btn'>
                                             <i onClick={closeQR}><Close /></i>
                                          </div>
                                          {/* <button className="close-btn" onClick={closeQR}>x</button> */}
                                       </div>
                                       <div className="qr--code flex-between-center">
                                          <div className="left">
                                             <div className="qr">
                                                <img src={`data:image/png;base64,${qrCode}`} alt="" />
                                             </div>
                                             <div className="box-desc flex-between-center">
                                                <div className="name">
                                                   Số tiền thanh toán:
                                                </div>
                                                <div className="price">
                                                   {formatPrice(order.grand_total)} đ
                                                </div>
                                             </div>
                                          </div>
                                          <div className="right">

                                             <div className="box-desc">
                                                <div className="title">Quét mã QR để thanh toán</div>
                                                <p>1. Mở ứng dụng Viettel Money trên điện thoại</p>
                                                <p>2. Trên Viettel Money, chọn biểu tượng <i><IconQrViettelMoney /></i> Quét mã</p>
                                                <p>3. Quét mã QR ở trang này và thanh toán trên ứng dụng</p>
                                                {/* <div className="process">
                                                   <div className="text">Mở ứng dụng Viettel Money trên điện thoại</div>
                                                </div>
                                                <div className="process">
                                                   <div className="text">Trên Viettel Money, chọn biểu tượng <i><IconQrViettelMoney /></i> Quét mã </div>
                                                </div>
                                                <div className="process">
                                                   <div className="text">Quét mã QR ở trang này và thanh toán trên ứng dụng</div>
                                                </div> */}
                                             </div>
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                              </Modal>
                           }
                        </div>
                     </div>
               }
            </div>
            :
            <React.Fragment>
               {!isLoad && <NotFound />}
            </React.Fragment>
         }
      </React.Fragment>
   )
}

const mapStateToProps = (state) => {
   const { order, payments } = state;
   return {
      order,
      payments
   };
};

export default connect(mapStateToProps, {
   fetchOrder,
   fetchPaymentMethod,
   paymentSubmit,
   payUrl
})(Payment)

